import React from 'react';
import SplitText from "./SplitText";
import './Hero.css';
import { FaLaptopCode, FaPalette, FaLaravel, FaMapMarkerAlt } from 'react-icons/fa';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="profile-picture">
          <img src="https://sambrereton.net.au/img/main_photo.png" alt="Samuel Brereton" />
        </div>
        <SplitText
            text="Samuel Brereton"
            className="hero-text"
            delay={100}
            duration={0.6}
            ease="power3.out"
            splitType="chars"
            from={{ opacity: 0, y: 40 }}
            to={{ opacity: 1, y: 0 }}
            threshold={0.1}
            rootMargin="-100px"
            textAlign="center"
        />
        <div className="roles">
          <div className="role-item">
            <FaLaptopCode className="role-icon" />
            <span>IT Consultant</span>
          </div>
          <div className="role-item">
            <FaPalette className="role-icon" />
            <span>UI/UX Designer</span>
          </div>
          <div className="role-item">
            <FaLaravel className="role-icon" />
            <span>Laravel Developer</span>
          </div>
        </div>
        <p className="subtitle location-text">
          <FaMapMarkerAlt className="location-icon" />
          Melbourne, Victoria, Australia
        </p>
      </div>
    </section>
  );
}

export default Hero;
